/**
 * This class is a parent class for all galleries.
 */
export default class BaseGallery {

  /**
   * Initialize gallery.
   *
   * @param {String} galleryName
   * @param {String} galleryPrefix should be ending with -
   */
    constructor(galleryName, galleryPrefix)
    {
        this.gallery = $('[data-' + galleryPrefix + 'gallery="' + galleryName + '"]');
        this.galleryToggles = $('[data-gallery-toggles="' + galleryName + '"]');
        this.gallerySlider = this.gallery.find('[data-gallery-slider]');

        this.sliderOptions = {
            lazyLoad: 'nearby',
            type: window.innerWidth <= 1052 ? 'loop' : 'fade',
            rewind: true,
            pagination: false,
            waitForTransition: true,
            width: '100%',
            keyboard: 'global',
            slideFocus: true,
            drag: true
        };

        this.slider = undefined;
    }

  /**
   * This function initialise the gallery and its toggles.
   *
   * @abstract
   */
    initGallery()
    {}
}
